<template>
  <div class="page-container user-page">
    <div class="top-bar">
      <div class="search-left">
        <el-input
          v-model="searchForm.userName"
          placeholder="请输入姓名"
          clearable
          size="small"
          style="width: 180px; margin-right: 8px"
          @keyup.enter.native="handleQuery"
          @clear="handleQuery"
        />
        <el-input
          v-model="searchForm.tel"
          placeholder="请输入手机号"
          clearable
          size="small"
          style="width: 160px; margin-right: 8px"
          @keyup.enter.native="handleQuery"
          @clear="handleQuery"
        />
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>

      <div class="action-right">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增人员</el-button>
      </div>
    </div>

    <div class="table-wrapper">
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        size="small"
        height="100%"
      >
        <el-table-column prop="userCode" label="登录账号" min-width="100" align="center"/>
        <el-table-column prop="userName" label="姓名" min-width="100" align="center"/>
        <el-table-column prop="tel" label="手机号" width="130" align="center"/>
        <el-table-column label="身份证号" width="180" align="center">
          <template slot-scope="scope">
            {{ maskIdNum(scope.row.idNum) }}
          </template>
        </el-table-column>
        <el-table-column prop="roleNames" label="岗位职责" min-width="180" align="center">
          <template slot-scope="scope">
            <div v-if="splitRoleNames(scope.row.roleNames).length" class="role-tags">
              <el-tag
                v-for="roleName in splitRoleNames(scope.row.roleNames)"
                :key="roleName"
                size="mini"
              >
                {{ roleName }}
              </el-tag>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" plain size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        :current-page.sync="pagination.pageNo"
        :page-size.sync="pagination.pageSize"
        :page-sizes="[10, 20, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <UserDialog
      :key="userDialogKey"
      :visible.sync="dialogVisible"
      :user-code="currentUserCode"
      @success="handleDialogSuccess"
    />
  </div>
</template>

<script>
// 服务
import { userService } from './user.service';
// 工具函数
import { formatDateTime } from '@/features/common/utils/dateTimeUtil.js';
// 组件
import UserDialog from './userDialog.vue';

export default {
  name: 'OrgUserList',
  components: { UserDialog },
  data () {
    return {
      searchForm: {
        userName: '',
        tel: ''
      },
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      currentUserCode: null,
      userDialogKey: 0
    };
  },
  methods: {
    loadData () {
      this.tableLoading = true;
      const params = {
        ...this.searchForm,
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize
      };
      userService.queryPage(params).then(res => {
        const page = res.data || {};
        this.tableData = page.rows || [];
        this.pagination.total = page.total || 0;
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    handleQuery () {
      this.pagination.pageNo = 1;
      this.loadData();
    },
    handleReset () {
      this.searchForm = { userName: '', tel: '' };
      this.handleQuery();
    },
    handleSizeChange () {
      this.pagination.pageNo = 1;
      this.loadData();
    },
    handleCurrentChange () {
      this.loadData();
    },
    handleAdd () {
      this.currentUserCode = null;
      this.userDialogKey += 1;
      this.$nextTick(() => { this.dialogVisible = true; });
    },
    handleEdit (row) {
      this.currentUserCode = row.userCode;
      this.userDialogKey += 1;
      this.$nextTick(() => { this.dialogVisible = true; });
    },
    handleDelete (row) {
      this.$confirm(`确定删除人员"${row.userName}"吗？删除后该用户将无法登录系统。`, '删除确认', {
        type: 'warning',
        confirmButtonText: '确定删除',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        this.tableLoading = true;
        userService.deleteUser(row.userCode).then(() => {
          this.$message.success('删除成功');
          if (this.tableData.length === 1 && this.pagination.pageNo > 1) {
            this.pagination.pageNo -= 1;
          }
          this.loadData();
        }).finally(() => {
          this.tableLoading = false;
        });
      }).catch(() => {});
    },
    handleDialogSuccess () {
      this.loadData();
    },
    maskIdNum (idNum) {
      if (!idNum || idNum.length < 10) return idNum || '-';
      return idNum.substring(0, 6) + '********' + idNum.substring(idNum.length - 4);
    },
    splitRoleNames (roleNames) {
      if (!roleNames) return [];
      return String(roleNames)
        .split(/[、,，]/)
        .map(item => item.trim())
        .filter(Boolean);
    },
    formatDateTime
  },
  created () {
    this.loadData();
  }
};
</script>

<style scoped lang="scss">
.user-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #fff;
}

/* 顶部操作栏样式 */
.top-bar {
  display: flex;
  justify-content: space-between; /* 左右两端对齐 */
  align-items: center;
  flex-shrink: 0;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5; /* 底边框分割，实现上下区域分离 */
}

.search-left {
  display: flex;
  align-items: center;
}

.action-right {
  display: flex;
  align-items: center;
}

/* 表格区域 */
.table-wrapper {
  flex: 1;
  overflow: hidden;
}

/* 分页条 */
.pagination-bar {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
}

.role-tags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
}
</style>
